Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Focusable95615449",
  {"root":"Focusable95615449--root","focus-box":"Focusable95615449--focus-box","focus-box-error":"Focusable95615449--focus-box-error"},
  ".Focusable95615449--focus-box{outline:0}.Focusable95615449--focus-box-error{outline:0}",
  1,
  "Focusable95615449"
);
__webpack_require__.stylable.$.register(exports.default)
